// extracted by mini-css-extract-plugin
export default {"btnContent":"loading_button_btnContent__Y594U"};